import Vue from 'vue';

const EventBus = new Vue({
  data: {
    pending_redirect: null,
  },
  methods: {
    setRedirect: function(next) {
      this.pending_redirect = next;
    },
    redirect: function() {
      if (this.pending_redirect) {
        let next = this.pending_redirect;
        this.pending_redirect = null;
        return next();
      }
    },
  },
});

EventBus.$on('requiresAuth', function(next) {
  if (next && this.pending_redirect == null) this.setRedirect(next);
});

EventBus.$on('login', function() {
  // this.redirect();
});

export default EventBus;
